import { Directive, DoCheck, ElementRef, Input } from '@angular/core';
import { isTimestamp } from '../services/is-timestamp.util';

@Directive({
  selector: '[fileNameDisplay]',
  standalone: false,
})
export class FileNameDisplayDirective implements DoCheck {
  @Input() fileName: string;

  isBusy: boolean = false;

  constructor(public elementRef: ElementRef) {}

  ngDoCheck(): void {
    this.elementRef.nativeElement.innerHTML = this.getDisplay(this.fileName);
  }

  getDisplay(name: any) {
    if (!name) {
      return '';
    }
    const ext = name.split('.').length > 1 ? name.split('.').pop() : '';
    const nameArr = name.split('_');
    const isTime = isTimestamp(nameArr.pop().split('.')[0]);
    let savedName = '';
    if (isTime) {
      savedName = nameArr.length ? nameArr.join('_') : name.split('.')[0];
    } else {
      const nameSplit = name.split('.');
      savedName = nameSplit.slice(0, -1).join('.');
    }

    return savedName.replace(/[^a-zA-Z0-9-] /g, '_') + (ext && ext !== 'undefined' ? '.' + ext : '');
  }
}
